module.exports = __webpack_public_path__ + "static/img/letimg.fa669f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/letimg.png
// module id = l3GJ
// module chunks = 0